<template>
    <ul class="test">
      <slot name="pre-nav"></slot>
      <li>
        <router-link :to="{ 'name': 'create-transaction' }">New Transaction</router-link>
      </li>
      <li>
        <router-link :to="{ 'name': 'address-book' }">Address Book</router-link>
      </li>
      <slot name="post-nav"></slot>
    </ul>
</template>

<script>
export default {
  name: 'ShipperNav'
}
</script>

<style scoped lang="scss">
@import 'styles.scss';
</style>
